<template>
  <div class="container">
    <ul class="nav justify-content-start justify-content-md-center flex-nowrap">
      <li class="nav-item">
        <a class="nav-link" href="https://ticketorganizer.eu/organizer/tourismusverband-st-anton-am-arlberg">Events</a>
      </li>
      <li class="nav-item">
        <a class="nav-link active" aria-current="page" href="#">Wahlabo</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://ticketorganizer.eu/organizer/tourismusverband-st-anton-am-arlberg#vouchers">GUTSCHEINE</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://ticketorganizer.eu/organizer/tourismusverband-st-anton-am-arlberg#info">Infos</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://ticketorganizer.eu/organizer/tourismusverband-st-anton-am-arlberg#contact">Kontakt</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Tabs"
}
</script>

<style scoped>
.nav {
  margin: 10px 0 10px 0;
}
.nav-item {
  border-bottom: 1px solid #EDEDED;
}
.nav-link {
  text-transform: uppercase;
  color: #333333;
  font-weight: bold;
}
.nav-link.active, .nav-link:hover {
  color: #333333;
  border-bottom: solid 1px #333333;
}
@media (max-width: 768px) {
  .nav {
    overflow: scroll !important;
  }
}
</style>